import React from "react";
import PageHeader from "../../PageHeader";
import EditGenerateRegistrationLinkForm from "./EditGenerateRegistrationLinkForm";
import { ReactComponent as RegistrationLinkIcon } from "../../../images/registrationlinkimage/registrationlinkimage.svg";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import useStyles from "../../../../styles";




function EditGenerateRegistrationLink() {
  const classes = useStyles();

  const Heading = [
    {
      id: 1,
      pageicon: <RegistrationLinkIcon />,
      mainheading: "Edit Registration Link",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/registrationlink",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <EditGenerateRegistrationLinkForm />
    </div>
  );
}
export default EditGenerateRegistrationLink;
